import { Link } from "@mobi/ds"
import DropdownMenuMobile from "../DropdownMenuMobile"

import IconChevronDown from "@mobi/ds/static/icons/outlined/seta-baixo.svg"
import IconUser from "@mobi/ds/static/icons/outlined/user.svg"

const DropdownApp = ({
  toggleDropDown,
  toggle,
  menuList,
  menuContent,
  handleMenuOpenAccountLink,
  utmsHeaderMenuCheckingAccount,
  utmsHeaderMenuOpenAccount,
  handleSubmenuOpenAccountLink,
  openAccountLink = "/?utm_source=st&utm_medium=nd&utm_campaign=st-conv-nd-st-nd-all&utm_content=nd-nd-nd-iacnta-nd-pfaqu-MT00001342-rvproduto",
}) => {
  return (
    <div className="ds-header__mobile-menu">
      <button
        id="hamburguer-menu"
        className={`ds-header__mobile-menu__hamburger_menu ${
          toggle ? "open" : "collapsed"
        }`}
        onClick={toggleDropDown}
        aria-label="Menu"
        aria-expanded={toggle}
      >
        <div>
          <span className="line" />
          <span className="line" />
          <span className="line" />
        </div>
        <span className="label open" />
      </button>
      <div
        className={`ds-header__mobile-menu__container ${
          toggle ? "-is-open" : ""
        }`}
      >
        <ul className="ds-header__menu-list">
          {menuList.map(({ type, action, id, label, content }, index) => {
            const actionList = type === "menu" ? () => action(index) : () => {}
            const isShow = menuList[index].show
            const menuItem =
              type === "menu" ? (
                <button
                  className={`ds-header__menu-item ${
                    isShow ? "ds-header__menu-item--active" : ""
                  }`}
                  onClick={actionList}
                  aria-expanded={isShow}
                >
                  <span>
                    {label}
                    <IconChevronDown />
                  </span>
                </button>
              ) : (
                <a href={action} className="ds-header__menu-item">
                  {label}
                </a>
              )
            return (
              <li key={`menu-item-${id}-${label}-${type}`}>
                {menuItem}
                <DropdownMenuMobile
                  key={`dropdown-menu-mobile-${label}`}
                  menuContent={menuContent}
                  show={isShow}
                  content={content}
                  openAccountLink={openAccountLink}
                  utmsHeaderMenuCheckingAccount={utmsHeaderMenuCheckingAccount}
                  handleSubmenuOpenAccountLink={handleSubmenuOpenAccountLink}
                />
              </li>
            )
          })}
        </ul>
        <div className="ds-header__menu-open-account">
          <Link
            href={`https://www.itau.com.br/contas/conta-corrente?utm_source=st&utm_medium=nd&utm_campaign=st-conv-nd-st-nd-all&utm_content=nd-nd-nd-iacnta-nd-pfaqu-MT00001342-rvproduto${utmsHeaderMenuOpenAccount}`}
            target="_blank"
            rel="noreferrer"
            onClick={handleMenuOpenAccountLink}
          >
            <IconUser />
            Abra sua conta no Itaú
          </Link>
        </div>
      </div>
    </div>
  )
}

export default DropdownApp
